const API_URL = 'https://www.aplikuj.pl'

function downloadAction(blob, fileName) {
  // IE doesn't allow using a blob object directly as link href
  // instead it is necessary to use msSaveOrOpenBlob
  if (window.navigator && window.navigator.msSaveOrOpenBlob) {
    window.navigator.msSaveOrOpenBlob(blob)
    return
  }

  const data = URL.createObjectURL(blob)
  const a = document.createElement("a")

  document.body.appendChild(a)
  a.href = data
  a.setAttribute(
    'download',
    fileName
  )
  a.click()

  setTimeout(function(){
    // For Firefox it is necessary to delay revoking the ObjectURL
    window.URL.revokeObjectURL(data)
  }, 100);
  document.body.removeChild(a)
}

async function generatorRequest(params) {
  let formBody = []
  for (let property in params) {
    const encodedKey = encodeURIComponent(property)
    const encodedValue = encodeURIComponent(JSON.stringify(params[property]))
    formBody.push(encodedKey + "=" + encodedValue)
  }
  formBody = formBody.join("&")

  try {
    const response = await fetch('/cv/kreator/download/', {
      method: 'POST',
      body: formBody,
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
      },
    })
    return response

  } catch(err) {
    console.log('request err', err)
    return undefined
  }
}

async function downloadPdf(data, formValid) {

  if ( !formValid ) {
    alert('Proszę poprawie wypełnić sekcję Informacje personalne.');
    return;
  } else {
    const params = {
      ...data,
      format: 'pdf'
    }
    const response = await generatorRequest(params)
    if (response) {
      const blob = await response.blob()
      downloadAction(blob, `cv-${data.firstName.toLowerCase()}-${data.lastName.toLowerCase()}.pdf`)
    }
    return 'error'
  }
}



async function getPreview(data) {
  const params = {
    ...data,
    format: 'html'
  }
  const response = await generatorRequest(params)
  if (response) {
    const preview = await response.text()
    return preview
  }
  return 'error'
}

export {
  downloadPdf,
  getPreview,
  API_URL
}